<template>
    <Paper
        slot="right"
        class="p-4 d-flex justify-content-center"
        style="min-height:160px;"
    >
        <img :src="logo" class="cute-logo" />
    </Paper>
</template>

<script>
import CuteSvg from '~/assets/img/cut-e.svg';

export default {
    name: 'CuteLogo',
    data: () => ({
        logo: CuteSvg,
    }),
};
</script>

<style scoped>
.cute-logo {
    max-width: 150px;
    max-height: 150px;
    width: 100%;
    height: auto;
    object-fit: scale-down;
}
</style>
